import type { AmbientEvaluatorInput, AmbientOpportunity } from './ambientTypes'
import { runHeuristics } from './ambientEvaluatorHeuristics'
import { applyDismissalFilter } from './ambientDismissalStore'

const MAX_ACTIVE = 1

/**
 * Pure evaluator: takes signals + workspace + dismissal state, returns
 * the top-scoring opportunity (empty array when nothing valid remains).
 * All rate limiting, off-topic priority, LLM refine, and Cr checks live
 * outside — this function is deterministic and pure so heuristics can be
 * unit-tested without any I/O.
 */
export const evaluateAmbientOpportunities = (input: AmbientEvaluatorInput): AmbientOpportunity[] => {
  const raw = runHeuristics(input)
  const filtered = applyDismissalFilter(raw, input.dismissed, input.muted, input.now)
  const alive = filtered.filter((opportunity) => opportunity.expiresAt > input.now)
  const deduped: AmbientOpportunity[] = []
  const seen = new Set<string>()
  alive
    .sort((left, right) => right.score - left.score)
    .forEach((opportunity) => {
      if (seen.has(opportunity.id)) return
      seen.add(opportunity.id)
      deduped.push(opportunity)
    })
  return deduped.slice(0, MAX_ACTIVE)
}
